import { AuctionType } from '../../auctions/types';

export const auctionGradients = {
  purebred: '#139d45', //, #15a649, #18ae4e, #1ab752, #1cc057',
  presort: '#ef3f0e', //, #f0491b, #f25226, #f35b30, #f4633a',
  feeders: '#203260', //, #25386a, #293e74, #2e457f, #334b89',
  event: '#3391b5', //, #4197b9, #4d9dbc, #58a3c0, #63a9c4',
  timed: '#800080', //, #821b82, #842a84, #853685, #874187',
  other: '#c25b0c' //, #c7641b, #cc6d27, #d17632, #d67f3d'
};

export const AuctionGradientPicker = (saleType: AuctionType) => {
  let color = '';
  switch (saleType) {
    case AuctionType.Direct:
      color = auctionGradients.feeders;
      break;
    case AuctionType.Presort:
      color = auctionGradients.presort;
      break;
    case AuctionType.Purebred:
      color = auctionGradients.purebred;
      break;
    case AuctionType.Event:
      color = auctionGradients.event;
      break;
    case AuctionType.Timed:
      color = auctionGradients.timed;
      break;
    default:
      color = auctionGradients.other;
      break;
  }
  return color;
};

export const auctionColors = {
  purebred: '#139d45',
  purebredDark: '#0e7533',
  purebredLight: '#a8f7c5',
  presort: '#ef3f0e',
  presortDark: '#b32f0a',
  feeders: '#203260',
  feedersDark: '#1c2b52',
  event: '#3391b5',
  eventDark: '#266c87',
  timed: '#800080',
  timedDark: '#600060',
  other: '#c25b0c',
  otherDark: '#914409'
  // upCommingTimed: '#3ab2d1',
  // upCommingTimedDark: '#1c90ad',
  // upCommingSale: '#5850EC',
  // upCommingSaleDark: '#150f8e'
};

export const AuctionColorPicker = (saleType: AuctionType) => {
  let color = '';
  switch (saleType) {
    case AuctionType.Direct:
      color = auctionColors.feeders;
      break;
    case AuctionType.Presort:
      color = auctionColors.presort;
      break;
    case AuctionType.Purebred:
      color = auctionColors.purebred;
      break;
    case AuctionType.Event:
      color = auctionColors.event;
      break;
    case AuctionType.Timed:
      color = auctionColors.timed;
      break;
    default:
      color = auctionColors.other;
      break;
  }
  return color;
}; //todo consolidate with the other AuctionColorPicker
